import React from 'react';

import { Box } from '@material-ui/core';
import { ResponsiveBar, BarDatum } from '@nivo/bar';

import { keys } from '../config/constants';
import { CustomBarComponent } from './CustomBarComponent';
import { LocationUsersBarchart } from '../../../../api/types';

const marginOptions = { top: 0, right: 0, bottom: 0, left: 0 };

export const SingleVerticalBarChart = ({ barchartData }: { barchartData: LocationUsersBarchart[] }) => {
  return (
    <Box width="100%" height="42px">
      <ResponsiveBar
        data={barchartData as unknown as BarDatum[]}
        keys={keys}
        indexBy="id"
        margin={marginOptions}
        padding={0.7}
        innerPadding={2}
        layout="horizontal"
        colors="id"
        groupMode="stacked"
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={null}
        enableGridY={false}
        labelSkipWidth={22}
        labelSkipHeight={12}
        barComponent={CustomBarComponent}
      />
    </Box>
  );
};
